import OriginalHttpClient from 'yoshi-serverless-client';
import { appDefIds, getCurrentInstance } from '@wix/business-manager-api';
export class HttpClient extends OriginalHttpClient {
    constructor(appDefId = appDefIds.metaSite) {
        super();
        this.appDefId = appDefId;
        this.request = (method, options) => {
            const instance = getCurrentInstance(this.appDefId);
            return super.request(method, Object.assign(Object.assign({}, options), { headers: Object.assign({ authorization: instance }, options === null || options === void 0 ? void 0 : options.headers) }));
        };
    }
}
//# sourceMappingURL=http-client.js.map